// extracted by mini-css-extract-plugin
export default {"bannerWrapper":"banner_style_bannerWrapper__4yPeI","centerContainer":"banner_style_centerContainer__Egc1B","contentName":"banner_style_contentName__1+1Tz"};